import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "components/CustomComponents/DesignSystemButtons";
import { GlobalConfirmDialog } from "components/DesignSystem/sharedUiPatterns";
import { designColors } from "services/constants/designTokens";
import { bulkRejectButtonSx } from "./approveUi";

export const BulkApprovalBar = ({ selectedCount, loading, onApprove, onReject }) => {
  if (!selectedCount) return null;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, px: 2, py: 1, mt: 1.5,
      backgroundColor: designColors.slate100, border: `1px solid ${designColors.slate200}`, borderRadius: 1 }}>
      <Typography sx={{ fontWeight: 600, color: designColors.slate800 }}>
        {selectedCount} record(s) selected
      </Typography>
      <Box sx={{ flex: 1 }} />
      <SecondaryButton sx={bulkRejectButtonSx} disabled={loading} onClick={onReject}>Reject</SecondaryButton>
      <PrimaryButton loading={loading} onClick={onApprove}>Approve</PrimaryButton>
    </Box>
  );
};

export const PendingBulkApprovalActions = ({ selection }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const close = () => {
    if (selection.loading) return;
    setOpen(false);
    setReason("");
    setError("");
  };
  const reject = async () => {
    const trimmed = reason.trim();
    if (trimmed.length < 3 || trimmed.length > 255 || !/[a-zA-Z]/.test(trimmed)) {
      setError("Enter a reason with 3–255 characters and at least one letter.");
      return;
    }
    if (await selection.reject(trimmed)) {
      setOpen(false);
      setReason("");
      setError("");
    }
  };
  return (
    <>
      <BulkApprovalBar selectedCount={selection.selectedCount} loading={selection.loading}
        onApprove={selection.approve} onReject={() => setOpen(true)} />
      <GlobalConfirmDialog open={open && selection.selectedCount > 0} title="Reject Selected Requests"
        onCancel={close} onConfirm={reject} confirmLabel="Reject" cancelLabel="Cancel"
        loading={selection.loading} danger maxWidth="sm" reasonValue={reason}
        onReasonChange={(value) => { setReason(value); setError(""); }} reasonError={error}
        reasonPlaceholder="Enter a reason for rejection" reasonMinRows={2}>
        <Typography sx={{ fontSize: 14, lineHeight: 1.5, mb: 2 }}>
          Reason (required) - applied to all selected requests.
        </Typography>
      </GlobalConfirmDialog>
    </>
  );
};
